/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ChartNoAxesColumnDecreasing = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 20V10" }],
    ["path", { d: "M18 20v-4" }],
    ["path", { d: "M6 20V4" }]
  ]
];

export { ChartNoAxesColumnDecreasing as default };
//# sourceMappingURL=chart-no-axes-column-decreasing.js.map
